<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="Chapter1">
<p class="centerImage"><img alt="images" id="pg_15_3" src="images/pg_15_3.jpg"/></p>
<p class="caption">French West African troops captured in France. Following the Axis armistice with France, Mussolini was content that French colonial forces in Tunisia posed no threat to his position in Libya, allowing him to turn his back on them and attack British forces in Egypt. (<em class="italic">Normandie Collection</em>)</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 07_04_Chapter1.vue?7e7074e1